import React from "react";
import { TYPE_META, BLANK_CONFIG } from "@/components/delivery/destinationConstants";
import { buildConfig } from "@/components/delivery/destinationHelpers";
import { TypeSpecificFields } from "@/components/delivery/DestinationForm";
import { Section, Field, TextIn, Choice, INPUT } from "./obUi";

const BUYER_TYPES = [["email", "Email"], ["webhook", "Webhook / my own system"], ["crm_zapier", "Zapier / Make"], ["other", "Something else"]];
const ALL_TYPES = [...Object.entries(TYPE_META).map(([k, m]) => [k, m.label]), ["other", "Something else"]];

const TypePicker = ({ a, admin, ro, onPick }) => (admin ? (
  <select className={INPUT} value={a.delivery_type} disabled={ro} onChange={(e) => onPick(e.target.value)} data-testid="ob-delivery-type">
    {ALL_TYPES.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
  </select>
) : (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
    {BUYER_TYPES.map(([k, label]) => (
      <Choice key={k} ro={ro} on={a.delivery_type === k} onClick={() => onPick(k)} testId={`ob-delivery-${k}`}>{label}</Choice>
    ))}
  </div>
));

const TypeFields = ({ a, set, ro, form, setConfig }) => {
  if (a.delivery_type === "other") {
    return (
      <Field label="How would you like to get leads?" required wide hint="Tell us your CRM or system and who we should talk to about it">
        <TextIn a={a} set={set} ro={ro} area k="delivery_other" testId="ob-delivery-other" />
      </Field>
    );
  }
  if (a.delivery_type === "email") {
    return (
      <Field label="Send leads to" wide hint="Leave empty to use the contact email. Separate more than one with commas.">
        <input className={INPUT} value={form.to || ""} disabled={ro} placeholder={a.contact_email || "intake@firm.com"}
               onChange={(e) => setConfig("to", e.target.value)} data-testid="ob-delivery-email-to" />
      </Field>
    );
  }
  return (
    <fieldset disabled={ro} className="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <TypeSpecificFields type={a.delivery_type} config={form} setConfig={setConfig} />
    </fieldset>
  );
};

export const DeliverySection = ({ a, set, ro, admin }) => {
  const form = { ...BLANK_CONFIG, ...(a.delivery_form || {}) };
  const pick = (t) => { set("delivery_type", t); set("delivery_config", t === "other" ? {} : buildConfig({ type: t, config: form })); };
  const setConfig = (k, v) => {
    const next = { ...form, [k]: v };
    set("delivery_form", next);
    set("delivery_config", buildConfig({ type: a.delivery_type, config: next }));
  };
  return (
    <Section n={4} title="How leads reach you" testId="ob-section-delivery"
             hint="Each lead is sent to you the moment it comes in. Our team sends one test lead to check it works before you go live.">
      <Field label="Send my leads by" required wide><TypePicker a={a} admin={admin} ro={ro} onPick={pick} /></Field>
      <TypeFields a={a} set={set} ro={ro} form={form} setConfig={setConfig} />
      {a.delivery_type !== "other" && (
        <Field label="Notes for our team (optional)" wide hint="e.g. field names your system needs, or who to contact about it">
          <TextIn a={a} set={set} ro={ro} area k="delivery_other" testId="ob-delivery-notes" />
        </Field>
      )}
      <Field label="Also email a copy of each lead to (optional)" wide>
        <TextIn a={a} set={set} ro={ro} k="copy_email" type="email" testId="ob-copy-email" placeholder="e.g. intake@firm.com" />
      </Field>
    </Section>
  );
};
